<div class="page-container top-fix resize-index flex flex-col justify-start items-center h-full center-screen">
  <div class="white-card w-[25rem] flex flex-col gap-[1.25rem] px-[1.5rem] py-[2rem] mobile:px-[1em] mobile:py-[1em] scale-[3] lg:scale-100">
    <div class="flex flex-col items-start gap-[1.5rem]">
      @if (showLogo) {
        <div class="h-[5em] flex flex-col items-center self-stretch">
          <app-orca-logo
            [logoType]="'black'"
            [logoWidth]="'6.5em'"
            [logoHeight]="'6.5em'"
          />
        </div>
      }
      <div class="flex flex-col self-stretch">
        <span class="text-center font-1 mobile:text-[1.25em] bold500">Select organization</span>
      </div>
      <div data-qa="org-list"
           class="flex flex-col items-start self-stretch h-[20rem] mobile:h-[100%] overflow-y-auto">
        @if (isNewOrgCanBeCreated) {
          <div
            data-qa="create-org"
            class="p-[0.75rem] mobile:p-[0.75em] self-stretch flex flex-row justify-between org-row
                      items-center gap-[0.375rem] clickable border-bottom main-8"
            (click)="createOrganizationEmitter.emit()">
            <span class="font-6 mobile:text-[0.875em] bold400">New organization</span>
            <app-all-icons [iconNameAndStyling]="'arrow-right.svg; icon-size-1em-mobile; main-8'"/>
          </div>
        }
        @for (org of availableOrganization; track org) {
          <div
            [attr.data-qa]="'org-' + org.organization.name"
            class="p-[0.75rem] mobile:p-[0.75em] self-stretch flex flex-row justify-between org-row
                    items-center gap-[0.375rem] clickable border-bottom"
            (click)="selectOrganizationEmitter.emit(org.organization)">
              <span class="font-6 mobile:text-[0.875em] bold400">{{org.organization.name}}</span>
              <app-all-icons [iconNameAndStyling]="'arrow-right.svg; icon-size-1em-mobile;'"/>
          </div>
        }
      </div>
    </div>
  </div>
</div>
